<template>
	<ul class="languagepicker header-languagepicker">
		<template v-for="(language) in languagesSorted">
			<li :key="language[0]">
				<a href="javascript:void(0);" @click="switchLang(language[0])">
				<span v-bind="{class: 'icon-wog-flag-' + language[0] + ' fa-fw'}">
					<span v-for="n in language[2]" v-bind="{class: 'path' + n}"></span>
				</span>
				{{ language[1] }}
				</a>
			</li>
		</template>
	</ul>
</template>

<script>
	// import
	import {params} from '../../params';

	// export
	export default {
		name: 'WidgetLanguagepicker',
		data: function() {
			return {
				// original languages array
				languages: params['languages'],

				// sorted languages array (used to build items in languagepicker block)
				languagesSorted: []
			}
		},
		created: function() {
			// save current language to cookie
			Cookies.set('language', this.$store.state.languageCurrent);

			// switch to another language if it's not default
			if (this.$store.state.languageCurrent !== params['languageDefault']) {
				this.switchLang(this.$store.state.languageCurrent);
			}

			// update sorted languages array
			this.languagesSorted = this.languagesSort();
		},
		methods: {
			/**
			 * Build array of languages with current language as first item.
			 * @param {String} [language] current language code
			 * @return {Array} languages array
			 */
			languagesSort: function(language) {
				// validate argument
				if ('undefined' === typeof language || null === language) {
					language = this.$store.state.languageCurrent;
				}

				// initial array
				const languageSorted = [];

				// get language name for the current language
				let languageName = null, languagePaths = null;
				this.languages.forEach(function (item) {
					if (item[0] === language) {
						languageName = item[1];
						languagePaths = item[2];
						return false;
					}
				});

				// add current language to sorted array as a first item
				languageSorted.push([language, languageName, languagePaths]);

				// loop through languages array and add the rest of languages to sorted array
				const _this = this;
				_this.languages.forEach(function (item) {
					if (item[0] !== language) {
						languageSorted.push([item[0], item[1], item[2]]);
					}
				});

				// result
				return languageSorted;
			},



			/**
			 * Switch to language.
			 * @param {String} language language to be set as current
			 */
			switchLang: function(language) {
				// detect if new language differs from the current
				if (language !== this.$store.state.languageCurrent) {
					// save language to cookie
					Cookies.set('language', language);

					// sort languages array
					this.languagesSorted = this.languagesSort(language);

					// expand languagepicker
					const $languagepicker = $('.languagepicker');
					$languagepicker.addClass('tiny');
					setTimeout(function () {
						$languagepicker.removeClass('tiny');
					}, 1000);

					// update project feature titles
					this.$store.dispatch('aboutFeaturesUpdate', language);
				}

				// detect whether to load messages
				if (language in this.$i18n.messages) {
					// run store action
					this.$store.dispatch('languageSet', {i18n: this.$i18n, language: language});
				} else {
					// run store action
					this.$store.dispatch('languageSetNew', {i18n: this.$i18n, language: language});
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/widgets/Languagepicker.vue